import { messages as profileMessages } from '../checkout-adventures/user-forms/ProfileInfo'
import {
  FormCheckbox,
  FormDropDown,
  FormInput,
  FormPhone,
  FormTextArea,
} from '../forms/final-form-fields'
import { defineMessages, FormattedMessage } from 'react-intl'

const messages = defineMessages({
  comments: {
    id: 'comments',
    defaultMessage: 'Comments',
  },
  transfer: {
    id: 'transfer_needed',
    defaultMessage: `I'm interested in booking a transfer`,
  },
})

export default function MainGuestForm({ shopKind, getPhoneInstance, countryCode }) {
  const genders = window.info.account.GENDER.filter((_, index) => index !== 2)
  return (
    <div className='fields'>
      <p className='section-title'>
        <FormattedMessage
          id='main_guest_info'
          defaultMessage='Main guest information'
        />
      </p>
      <div className='shadow-block'>
        <div className='main-form'>
          <div className='form-row'>
            <FormInput
              name='firstName'
              label={profileMessages.firstName}
              className='form-group'
              isRequired
            />
            <FormInput
              name='lastName'
              className='form-group'
              label={profileMessages.lastName}
              isRequired
            />
          </div>
          <div className='form-row'>
            <FormInput
              name='email'
              className='form-group'
              label={profileMessages.email}
              isRequired
            />
            <FormPhone
              name='phone'
              label={profileMessages.phone}
              isRequired
              getPhoneInstance={getPhoneInstance}
              className='form-group'
              countryCode={countryCode}
            />
          </div>
          {shopKind === 10 && (
            <div className='form-row'>
              <FormDropDown
                isArrayCollection
                name='gender'
                options={genders}
                title={profileMessages.gender}
                className='form-group no-min-height'
                isRequired
              />
              <div className='form-group'>
                <p className='notification-text'>
                  <FormattedMessage
                    defaultMessage='Required by the Liveaboard for its cabin pairing process'
                    id='required_by_the_Liveaboard'
                  />
                </p>
              </div>
            </div>
          )}
          <div className='form-group textarea-wrap'>
            <FormTextArea name='comments' label={messages.comments} />
          </div>
          <div className='form-row'>
            <FormCheckbox
              name='transferNeeded'
              label={messages.transfer}
              className='checkbox-wrap'
            />
          </div>
        </div>
      </div>
    </div>
  )
}
